module.exports = __webpack_public_path__ + "images/hunan_banner03.jpg?fc44dd5514492916c3ad6ab1ab47551d";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/hunan_banner03.jpg
// module id = 189
// module chunks = 1